/**
 * Feature flags for the dashboard client.
 *
 * Flip a flag to `true` to fully restore the gated behavior.
 */

/**
 * Issues UI — the Issues and Failures tabs (`/api/issues-v6`, `/api/failures`).
 * Flip to `false` to hide the sidebar link and redirect `/agent-analytics/issues`
 * to the analytics overview.
 */
export const ISSUES_UI_ENABLED = true;

/**
 * Annotations on Traces (conversations, runs, spans) plus Slack sync.
 * Flip to `false` to hide the tab, badges, and composer.
 */
export const ANNOTATIONS_ENABLED = true;

/**
 * The Analytics Studio (Reports, boards, insights, funnels, flows, retention)
 * is hidden: Dashboards v2 replaces it (TRO-466). Hidden, not deleted — build
 * with REACT_APP_LEGACY_STUDIO=on to bring back its routes, its nav entry,
 * boards in search, the chat's @-board picker and its app-start cache warms.
 * The server has the matching LEGACY_STUDIO switch on /api/boards. Public
 * board links (/analytics/public/:token) keep working either way.
 */
export const LEGACY_STUDIO_UI = String(process.env.REACT_APP_LEGACY_STUDIO || '').trim().toLowerCase() === 'on';
